import {Component, inject} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {CharityManagementComponent} from "./charity-management.component";
import {ColComponent, ContainerComponent, ListGroupDirective, ListGroupItemDirective, RowComponent} from "@coreui/angular";
import {ChooseYourGameComponent} from "../../components/choose-your-game/choose-your-game.component";
import {IGameQueryResult} from "../../interfaces/IGameQueryResult";
import {PermissionTypes} from "../../enum/PermissionTypes";
import {HasPermissionDirective} from "../../directives/permissions/has-permission";
import {CharityManagementScreenState} from "../../enum/CharityManagementScreenState";
import {MatButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import {CharityService} from "../../services/charity.service";
import {GameService} from "../../services/game.service";
import {
  MovePlayersPledgesBetweenCharitiesComponent
} from "../../components/charity/move-players-pledges-between-charities/move-players-pledges-between-charities.component";

/**
 * Single scope-aware charity-management page, replacing the former cross-game / game-admin
 * pair. Scope comes from route data (`isCrossGame`): global scope shows the game picker and
 * sets the game on choose; game scope uses the active game directly. Same management body.
 */
@Component({
  selector: 'app-charity-management-page',
  standalone: true,
  imports: [
    CharityManagementComponent,
    ContainerComponent,
    ChooseYourGameComponent,
    ColComponent,
    HasPermissionDirective,
    ListGroupDirective,
    ListGroupItemDirective,
    RowComponent,
    MatButton,
    MatIcon,
    MovePlayersPledgesBetweenCharitiesComponent
  ],
  templateUrl: './charity-management-page.component.html',
})
export class CharityManagementPageComponent {
  private route = inject(ActivatedRoute);
  private gameService = inject(GameService);
  private charityService: CharityService = inject(CharityService);

  protected isCrossGame = this.route.snapshot.data['isCrossGame'] === true;
  protected game: IGameQueryResult | null = this.isCrossGame ? null : this.gameService.activeGame();
  protected currentScreenState: CharityManagementScreenState = CharityManagementScreenState.SortAndView;
  protected readonly PermissionTypes = PermissionTypes;
  protected readonly charityManagementScreenState = CharityManagementScreenState;

  onGameChosen(chosenGameP: IGameQueryResult) {
    this.game = chosenGameP;
  }

  addNewCharities() {
    this.charityService.openAddCharityDialog(this.game?.Id!);
  }
}
